var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#BDC6E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9997 16.334C21.5597 16.334 16.333 21.5607 16.333 28.0007C16.333 34.4407 21.5597 39.6673 27.9997 39.6673C34.4397 39.6673 39.6663 34.4407 39.6663 28.0007C39.6663 21.5607 34.4397 16.334 27.9997 16.334ZM18.6663 28.0007C18.6663 27.289 18.7597 26.589 18.9113 25.924L24.488 31.5007V32.6673C24.488 33.9507 25.538 35.0007 26.8213 35.0007V37.2523C22.2363 36.669 18.6663 32.749 18.6663 28.0007ZM34.8713 34.3007C34.568 33.3557 33.7047 32.6673 32.6547 32.6673H31.488V29.1673C31.488 28.5257 30.963 28.0007 30.3213 28.0007H23.3213V25.6673H25.6547C26.2963 25.6673 26.8213 25.1423 26.8213 24.5007V22.1673H29.1547C30.438 22.1673 31.488 21.1173 31.488 19.834V19.3557C34.9063 20.7323 37.333 24.0923 37.333 28.0007C37.333 30.4273 36.388 32.644 34.8713 34.3007Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.86680180b6a841c89d2ee96c03397955.svg";
export { ForwardRef as ReactComponent };